/* eslint-disable camelcase */
import { handleActions } from 'redux-actions';
import { actions } from '@piwikpro/user-groups-crate';

const inUnderUserGroupsRoute = new RegExp('/user-groups/(.*)');

const {
  userGroupFetchInitialized,
  userGroupFetchSucceeded,
  userGroupFetchFailed,
} = actions;

interface IUserGroupDetailsAttributes {
  name: string
  created_at: string
  updated_at: string
  external_id: string
}

export interface IUserGroupDetails {
  id: string
  type: 'ppms/user-group'
  attributes: IUserGroupDetailsAttributes
}

export interface IUserGroupDetailsState {
  isLoading: boolean
  failed: boolean
  userGroup: IUserGroupDetails | null
}

const initialState: IUserGroupDetailsState = {
  isLoading: true,
  userGroup: null,
  failed: false,
};

const reducer = handleActions<IUserGroupDetailsState, any>({
  [userGroupFetchInitialized.toString()]: () => initialState,
  [userGroupFetchSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    userGroup: payload,
  }),
  [userGroupFetchFailed.toString()]: state => ({
    ...state,
    failed: true,
    isLoading: false,
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (!inUnderUserGroupsRoute.test(payload.location.pathname)) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
